import MarketsIcon from '@/assets/icons/Intro/markets.svg?react';
import SellerboxLogoIcon from '@/assets/icons/Intro/sellerbox-logo.svg?react';
import { Button } from '@/components/V3/Button';

interface Props {
  onStart: () => void;
}

export const Intro = ({ onStart }: Props) => {
  return (
    <div className="relative flex h-[100vh] flex-col items-center justify-between overflow-hidden  bg-[linear-gradient(180deg,#F2F0FF_0%,#FFFFFF_100%)] pt-[200px]">
      <div className="space-y-[74px]">
        <div className="flex flex-col items-center gap-7">
          <SellerboxLogoIcon />
          <div className="text-center text-gr-700 Body1S16">
            마켓마다 로그인 없이
            <br />
            나의 모든 데이터를 한번에 조회하세요
          </div>
        </div>
        <MarketsIcon className="mt-[74px]" />
      </div>
      <div className="fixed bottom-10 w-full px-5 text-center">
        <Button variant="Secondary" className="max-w-[400px]" onClick={onStart}>
          셀러박스 시작하기
        </Button>
      </div>
    </div>
  );
};
